module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-1-3.0460e5c7.png";